// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WH8T","right":"styles_right__1aIIB"};